import { useContext } from 'react';
import { AdminAuthContext } from '@/contexts/AdminAuthShared';

export const useAdminAuth = () => {
  const ctx = useContext(AdminAuthContext);
  if (!ctx) {
    throw new Error('useAdminAuth must be used within an AdminAuthProvider');
  }
  return ctx;
};

export default useAdminAuth;



